export const Organizer = 'DeFiGeek Community JAPAN';

export const ReferenceList = {
  forum: 'https://gov.defigeek.xyz/',
  discord: 'https://discord.gg/FQYXqVBEnh',
  github: 'https://github.com/DeFiGeek-Community',
  document: 'https://docs.yamato.fi/',
};
